// extracted by mini-css-extract-plugin
export default {"externalLink":"ZHcipT","serviceActionButton":"WDStDz","serviceLogo":"iWNxZy","serviceName":"MWhqAh","infoContainer":"e7P1Z8"};